import { Controller } from "@hotwired/stimulus"

// 行フォームの自動保存。保存ボタンを置かず、
//   - text input の change（値を変えたまま入力欄を離れたとき）
//   - 入力欄での Enter
// で form を submit する。連続送信は submitting フラグで抑止し、turbo:submit-end で解除する。
// さらに、直前に送った値を input の dataset.autosaveLastValue に覚えておき、
// 「Enter で送信 → そのまま blur」で同じ値が二重に PATCH されるのを防ぐ。
//
// 使い方(view):
//   form_with url: ..., method: :patch,
//             data: { controller: "autosave-row",
//                     action: "change->autosave-row#save keydown->autosave-row#saveOnEnter turbo:submit-end->autosave-row#reset" }
export default class extends Controller {
  connect() {
    this.submitting = false
    this.lastInput = null
  }

  save(event) {
    const input = event ? event.target : null
    if (input && !this.isTextInput(input)) return
    // Enter で送った直後の blur でも change が起きるため、直前に送った値と同じなら送らない
    if (input && input.dataset.autosaveLastValue === input.value) return

    this.submit(input)
  }

  // Enter は暗黙の submit を止めてから送る（change → 暗黙の submit で二重送信になるのを防ぐ）
  saveOnEnter(event) {
    if (event.key !== "Enter") return
    if (!this.isTextInput(event.target)) return

    event.preventDefault()
    this.submit(event.target)
  }

  reset(event) {
    this.submitting = false
    // 保存に失敗したときは同じ値での再送を許したいので、記録した値を捨てる
    if (this.lastInput && event?.detail?.success === false) delete this.lastInput.dataset.autosaveLastValue
    this.lastInput = null
  }

  submit(input) {
    if (this.submitting) return
    // 必須項目が空のまま送るとサーバー側で 422 になるため、送る前にブラウザの検証に任せる
    if (typeof this.element.checkValidity === "function" && !this.element.checkValidity()) {
      this.element.reportValidity()
      return
    }

    if (input) {
      input.dataset.autosaveLastValue = input.value
      this.lastInput = input
    }
    this.submitting = true
    this.element.requestSubmit()
  }

  isTextInput(target) {
    return target instanceof HTMLInputElement && target.type === "text"
  }
}
